import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        border: `3px solid ${theme.palette.error.light}`,
        borderRadius: "10px",
        width: "95%",
        height: "40vh !important",
        gap: theme.spacing(5),
        marginTop: theme.spacing(5),
        "@media (min-width: 1300px)": {
            height: "50vh !important",
        },
    },
    title: {
        fontWeight: "700 !important",
    },
    subtitle: {
        color: theme.palette.error.light,
    },
    icon: {
        height: `100px !important`,
        width: `100px !important`,
        color: theme.palette.info.main,
    },
}));
